module.exports = __webpack_public_path__ + "static/media/budget-no-data-MD.70577ead.jpg";